import actions from './actions';
import getters from './getters';
import mutations from './mutations';

// eslint-disable-next-line no-undef
const { state } = __VUE_WORDPRESS__;

export default {
  state: {
    ...state,
    ajaxLoading: false,
  },
  mutations,
  getters,
  actions,
};
